import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { IVerifyURLPayload } from '../interfaces/url-verification.interfaces';

@Injectable({
  providedIn: 'root'
})
export class UrlVerificationService {
  private http = inject(HttpClient);

  /**
   * Verifies the URL by making an HTTP GET request to the provided URL.
   * @param vanityName The vanity name extracted from the URL.
   * @param baseUrl The base URL for the tenant API.
   * @returns An Observable of IVerifyURLPayload.
   */
  verifyUrl(vanityName: string, baseUrl: string): Observable<IVerifyURLPayload> {
    const requestUrl = `${baseUrl}/vanity/${vanityName}`;
    return this.http.get<IVerifyURLPayload>(requestUrl).pipe(
      catchError(error => {
        console.error('Error fetching document:', error.message);
        return throwError(() => new Error('Error fetching document'));
      })
    );
  }
}
